<button
  type="button"
  class="btn d-flex gap-1 justify-content-center w-100 mt-2"
  [ngClass]="buttonClass"
  (click)="openEmailOfferModal()"
>
  <crnt-icon icon="envelope" />{{ content.buttonLabel }}
</button>
